import {
  LayoutColumnComponent,
  LayoutComponent,
  LayoutRowContainerComponent,
} from '@myre/ui-primitive-layouts';
import {
  NavbarComponent,
  NavbarLogoComponent,
} from '@myre/ui-primitive-navbar';

import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { InAppNavbarComponent } from '../in-app-navbar/in-app-navbar.component';

import { type ErrorPageCode, isErrorPageCode } from './error-page-code';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [
    LayoutColumnComponent,
    LayoutComponent,
    LayoutRowContainerComponent,
    NavbarComponent,
    NavbarLogoComponent,
    NgClass,
  ],
})
export class ErrorComponent extends InAppNavbarComponent {
  public errorCode: ErrorPageCode;
  public background: string;

  constructor() {
    super();

    this._title.setTitle('MYRE');
  }

  public ngOnInit(): void {
    this._activatedRoute.data.subscribe(data => {
      const errorCode: unknown = data.errorCode;

      if (!isErrorPageCode(errorCode)) {
        throw new Error(
          `The error page route declares no supported errorCode: ${String(errorCode)}`,
        );
      }

      this.errorCode = errorCode;
      this.background = `url(/assets/images/backgrounds/${errorCode}.gif)`;
    });
  }
}
